import { useEffect, useState, type FormEvent } from 'react';
import { api, stockerJeton, type Plateforme } from '../api/client';
import { MessageErreur } from '../components/Ui';

export function Connexion({
  surConnexion,
  surInscrire,
}: {
  surConnexion: () => void;
  surInscrire: () => void;
}) {
  // La plateforme se lit avant toute authentification : c'est elle qui décide
  // si « créer un compte » a un sens ici, ou s'il faut renvoyer vers INFRATEX.
  const [plateforme, setPlateforme] = useState<Plateforme | null>(null);
  useEffect(() => {
    api
      .plateforme()
      .then(setPlateforme)
      .catch(() => undefined);
  }, []);

  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState<unknown>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(evenement: FormEvent) {
    evenement.preventDefault();
    setErreur(null);
    setEnCours(true);
    try {
      const { token } = await api.connexion(email, motDePasse);
      stockerJeton(token);
      surConnexion();
    } catch (e) {
      setErreur(e);
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="page-connexion">
      <div className="boite">
        <div className="marque">
          <img className="signe" src="/favicon.svg" alt="" width="44" height="44" />
          <div className="nom">INFRATEX SMPP</div>
          <div className="produit">
            Console
            {plateforme ? (plateforme.mode === 'test' ? ' — plateforme de test' : '') : ''}
          </div>
        </div>

        <div className="carte">
          <div className="corps">
            <h2 style={{ marginBottom: 16, fontSize: 18 }}>Connexion</h2>
            <MessageErreur erreur={erreur} />

            <form onSubmit={soumettre}>
              <label className="champ" style={{ marginBottom: 14 }}>
                <span>Adresse électronique</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username"
                  required
                  autoFocus
                />
              </label>

              <label className="champ" style={{ marginBottom: 18 }}>
                <span>Mot de passe</span>
                <input
                  type="password"
                  value={motDePasse}
                  onChange={(e) => setMotDePasse(e.target.value)}
                  autoComplete="current-password"
                  required
                />
              </label>

              <button
                className="primaire"
                type="submit"
                disabled={enCours}
                style={{ width: '100%' }}
              >
                {enCours ? 'Connexion…' : 'Se connecter'}
              </button>
            </form>

            {plateforme?.signup_enabled && (
              <div className="aide">
                Pas encore de compte ?{' '}
                <button type="button" className="lien" onClick={surInscrire}>
                  En créer un
                </button>{' '}
                — gratuit et immédiat sur la plateforme de test.
              </div>
            )}

            <div className="aide">
              {plateforme?.mode === 'production'
                ? 'Plateforme de production. Les comptes y sont ouverts par INFRATEX après intégration ; vos essais se font sur la plateforme de test, avec ses propres identifiants.'
                : 'Plateforme de test : rien n’atteint un réseau GSM, rien n’est facturé. La production est un service distinct.'}{' '}
              Les espaces ouverts — client, développeur, administration — dépendent de votre rôle.
              Le serveur en décide, jamais la console.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
